export const Youtube = {
  uid: 'v',
  type: 'video'
};
